// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opps-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.opps-header .opps-header-buttons {
  width: 100%;
  display: flex;
  margin-right: 20px;
  justify-content: flex-end;
  column-gap: 12px;
}
.opps-header .opps-lastupdate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.opps-header .opps-search-box {
  color: #6A8991;
  font-size: 17px;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.opps-header .opps-search-box .opps-search-input {
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 17px;
  color: #6A8991;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Opportunities/Opportunities.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AACF;AAEC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;AAGC;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AADF;AAGE;EACC,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AADH","sourcesContent":[".opps-header {\n\tmin-height: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\n\t.opps-header-buttons {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tmargin-right: 20px;\n\t\tjustify-content: flex-end;\n\t\tcolumn-gap: 12px;\n\t}\n\n\t.opps-lastupdate {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n\n\t.opps-search-box {\n\t\tcolor: #6A8991;\n\t\tfont-size: 17px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-left: 10px;\n\n\t\t.opps-search-input {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\toutline: 0;\n\t\t\tfont-size: 17px;\n\t\t\tcolor: #6A8991;\n\t\t\theight: 30px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
